import React from 'react';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = ({ phoneNumber, label, primary = false }) => {
  const handleClick = () => {
    const cleanNumber = phoneNumber.replace(/\s+/g, '');
    window.open(`https://wa.me/${cleanNumber}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className={`
        inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-semibold
        transition-all duration-300 transform hover:scale-105 hover:shadow-lg
        ${primary 
          ? 'bg-[#AA6A03] text-white hover:bg-[#8B5502]' 
          : 'bg-white text-[#AA6A03] border-2 border-[#AA6A03] hover:bg-[#FFF8F1]'
        }
      `}
    >
      <MessageCircle className="h-5 w-5" />
      <span>{label}</span>
    </button>
  );
};

export const StickyWhatsAppButton = ({ phoneNumber }) => {
  const handleClick = () => {
    const cleanNumber = phoneNumber.replace(/\s+/g, '');
    window.open(`https://wa.me/${cleanNumber}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl
                 hover:scale-110 transition-transform duration-300 animate-pulse hover:animate-none"
      aria-label="Contact on WhatsApp"
    >
      <MessageCircle className="h-7 w-7" />
    </button>
  );
};
